var color = zindex = spacing = flex = layout = border = void 0;
var border = {
  "radius": {
    "comment": "A maioria dos componentes utiliza arredondamento nas bordas, use 'none' para as poucas exceções.",
    "none": 0,
    "xs": "4px",
    "sm": "8px",
    "md": "12px",
    "lg": "24px",
    "pill": "999px",
    "circle": "50%"
  }
};
var layout = {
  "xs": {
    "breakpoint": {
      "min": "320px",
      "max": "575px"
    },
    "container": "100%",
    "columns": 4,
    "margin": "24px",
    "gutters": "16px"
  },
  "sm": {
    "breakpoint": {
      "min": "576px",
      "max": "767px"
    },
    "container": "100%",
    "columns": 8,
    "margin": "24px",
    "gutters": "16px"
  },
  "md": {
    "breakpoint": {
      "min": "768px",
      "max": "959px"
    },
    "container": "100%",
    "columns": 8,
    "margin": "40px",
    "gutters": "16px"
  },
  "lg": {
    "breakpoint": {
      "min": "960px",
      "max": "1199px"
    },
    "container": "100%",
    "columns": 12,
    "margin": "40px",
    "gutters": "16px"
  },
  "xl": {
    "breakpoint": {
      "min": "1200px",
      "max": "1439px"
    },
    "container": "1280px",
    "columns": 12,
    "margin": "40px",
    "gutters": "32px"
  },
  "xxl": {
    "breakpoint": {
      "min": "1440px"
    },
    "container": "1600px",
    "columns": 12,
    "margin": "64px",
    "gutters": "32px"
  }
};
var flex = {
  "row": {
    "default": {
      "display": "flex",
      "flexDirection": "row",
      "flexWrap": "wrap"
    },
    "centered": {
      "display": "flex",
      "flexDirection": "row",
      "flexWrap": "wrap",
      "justifyContent": "center",
      "alignItems": "center"
    },
    "justifyCenter": {
      "display": "flex",
      "flexDirection": "row",
      "flexWrap": "wrap",
      "justifyContent": "center"
    },
    "justifyStart": {
      "display": "flex",
      "flexDirection": "row",
      "flexWrap": "wrap",
      "justifyContent": "flex-start"
    },
    "justifyEnd": {
      "display": "flex",
      "flexDirection": "row",
      "flexWrap": "wrap",
      "justifyContent": "flex-end"
    },
    "justifySpaceAround": {
      "display": "flex",
      "flexDirection": "row",
      "flexWrap": "wrap",
      "justifyContent": "space-around"
    },
    "justifySpaceBetween": {
      "display": "flex",
      "flexDirection": "row",
      "flexWrap": "wrap",
      "justifyContent": "space-between"
    },
    "alignCenter": {
      "display": "flex",
      "flexDirection": "row",
      "flexWrap": "wrap",
      "alignItems": "center"
    },
    "alignStart": {
      "display": "flex",
      "flexDirection": "row",
      "flexWrap": "wrap",
      "alignItems": "flex-start"
    },
    "alignEnd": {
      "display": "flex",
      "flexDirection": "row",
      "flexWrap": "wrap",
      "alignItems": "flex-end"
    }
  },
  "column": {
    "default": {
      "display": "flex",
      "flexDirection": "column",
      "flexWrap": "wrap"
    },
    "centered": {
      "display": "flex",
      "flexDirection": "column",
      "flexWrap": "wrap",
      "justifyContent": "center",
      "alignItems": "center"
    },
    "justifyCenter": {
      "display": "flex",
      "flexDirection": "column",
      "flexWrap": "wrap",
      "justifyContent": "center"
    },
    "justifyStart": {
      "display": "flex",
      "flexDirection": "column",
      "flexWrap": "wrap",
      "justifyContent": "flex-start"
    },
    "justifyEnd": {
      "display": "flex",
      "flexDirection": "column",
      "flexWrap": "wrap",
      "justifyContent": "flex-end"
    },
    "justifySpaceAround": {
      "display": "flex",
      "flexDirection": "column",
      "flexWrap": "wrap",
      "justifyContent": "space-around"
    },
    "justifySpaceBetween": {
      "display": "flex",
      "flexDirection": "column",
      "flexWrap": "wrap",
      "justifyContent": "space-between"
    },
    "alignCenter": {
      "display": "flex",
      "flexDirection": "column",
      "flexWrap": "wrap",
      "alignItems": "center"
    },
    "alignStart": {
      "display": "flex",
      "flexDirection": "column",
      "flexWrap": "wrap",
      "alignItems": "flex-start"
    },
    "alignEnd": {
      "display": "flex",
      "flexDirection": "column",
      "flexWrap": "wrap",
      "alignItems": "flex-end"
    }
  }
};
var spacing = {
  "inner": {
    "base": "4px",
    "base02": "8px",
    "base03": "12px",
    "base04": "16px",
    "base05": "20px",
    "base06": "24px",
    "base08": "32px",
    "base10": "40px",
    "base12": "48px",
    "base14": "56px"
  },
  "layout": {
    "base": "8px",
    "base02": "16px",
    "base03": "24px",
    "base04": "32px",
    "base05": "40px",
    "base06": "48px",
    "base07": "56px",
    "base08": "64px",
    "base10": "80px",
    "base12": "96px",
    "base15": "120px"
  }
};
var zindex = {
  "fab": 100,
  "navigation": 200,
  "popover": 300,
  "backdrop": 500,
  "drawer": 510,
  "modal": 520,
  "dialog": 530,
  "modalContent": 550,
  "snackbar": 600,
  "tooltip": 700,
  "aboveAll": 1000
};
color = {
  "base": {
    "neutral": {
      "0": "#ffffff",
      "50": "#f2f4f8",
      "100": "#dde1e6",
      "200": "#c1c7cd",
      "300": "#a2a9b0",
      "400": "#878d96",
      "500": "#697077",
      "600": "#4d5358",
      "700": "#343a3f",
      "800": "#21272b",
      "900": "#191f23"
    },
    "blue": {
      "100": "#99d6ff",
      "200": "#7cc3f2",
      "300": "#60aadb",
      "400": "#4b94c5",
      "500": "#387ba8",
      "600": "#2a658c",
      "700": "#1f4f70",
      "800": "#173c54",
      "900": "#0e2636"
    },
    "green": {
      "100": "#e4f0ed",
      "200": "#bfdbd5",
      "300": "#98cbc0",
      "400": "#7ac2b2",
      "500": "#5bbaa5",
      "600": "#3cb096",
      "700": "#20a483",
      "800": "#0d8f6e",
      "900": "#017558"
    },
    "red": {
      "100": "#facdcd",
      "200": "#f7a8a8",
      "300": "#f28585",
      "400": "#e36262",
      "500": "#ce4242",
      "600": "#ad2828",
      "700": "#9e2424",
      "800": "#690d0d",
      "900": "#420707"
    },
    "yellow": {
      "100": "#fff3de",
      "200": "#ffe6ba",
      "300": "#ffd894",
      "400": "#ffcd70",
      "500": "#ffc04c",
      "600": "#ffb429",
      "700": "#ffa600",
      "800": "#de9000",
      "900": "#bd7b00"
    }
  },
  "feedback": {
    "comment": "As cores de feedback servem como reforço visual em toda e qualquer comunicação de estado do sistema ou fluxo de negócio. Podem ser usadas como fundos, textos, ícones ou bordas.",
    "positive": {
      "main": "#20a483",
      "light": "#e4f0ed"
    },
    "warning": {
      "main": "#ffa600",
      "light": "#fff3de"
    },
    "negative": {
      "main": "#ce4242",
      "light": "#facdcd"
    },
    "informative": {
      "main": "#387ba8",
      "light": "#f2f4f8"
    },
    "neutral": {
      "main": "#697077",
      "light": "#dde1e6"
    }
  },
  "icon": {
    "comment": "Cores para comunicação em forma de ícones.",
    "primary": "#191f23",
    "muted": "#697077",
    "inverted": "#ffffff",
    "disabled": {
      "main": "#a2a9b0",
      "inverted": "rgba(255, 255, 255, 0.35)"
    }
  },
  "interaction": {
    "comment": "Cores usadas para indicar elementos interativos, bem como seus estados.",
    "primary": {
      "main": "rgba(0, 0, 0, 0)",
      "hover": "rgba(25, 31, 35, 0.1)",
      "pressed": "rgba(25, 31, 35, 0.1)"
    },
    "solid": {
      "comment": "Cor sólida de interação para botões que precisam de fundo sólido.",
      "main": "#ffffff",
      "hover": "#dde1e6",
      "pressed": "#dde1e6",
      "border": {
        "main": "#dde1e6",
        "hover": "#dde1e6",
        "pressed": "#dde1e6"
      }
    },
    "inverted": {
      "comment": "Cor utilizada em casos em que é as cores padrão não atingem o nível de contraste necessário em relação ao fundo.",
      "main": "#ffffff",
      "hover": "rgba(255, 255, 255, 0.85)",
      "pressed": "rgba(255, 255, 255, 0.85)",
      "border": {
        "main": "#ffffff",
        "hover": "#ffffff",
        "pressed": "#ffffff"
      }
    },
    "invertedSecondary": {
      "comment": "Cor utilizada em casos em que é as cores padrão não atingem o nível de contraste necessário em relação ao fundo.",
      "main": "rgba(0, 0, 0, 0)",
      "hover": "rgba(255, 255, 255, 0.1)",
      "pressed": "rgba(255, 255, 255, 0.1)",
      "border": {
        "main": "#ffffff",
        "hover": "#ffffff",
        "pressed": "#ffffff"
      }
    }
  },
  "separator": {
    "comment": "As cores de separadores servem para dividir conteúdo, seja em blocos ou em containers. Elas devem seguir a mesma hierarquia do agrupamento de conteúdo.",
    "main": "#697077",
    "heavy": "#191f23",
    "light": "#c1c7cd",
    "inverted": "#ffffff",
    "disabled": {
      "main": "#a2a9b0",
      "inverted": "rgba(255, 255, 255, 0.35)"
    }
  }
};
export { border, color, flex, layout, spacing, zindex };